import {createApp} from 'vue';
import {ScrollSpy} from 'bootstrap';
import marketo from './js/marketo';

marketo();

async function loadCountdown(el){
	const Countdown = await import('./components/Countdown.vue');
	const app = createApp( Countdown.default, el.dataset );
	app.mount(el);
}
document.addEventListener('DOMContentLoaded', function(){
	const container = document.querySelector('.countdown');
	if( container ){
		console.log('container');
		loadCountdown(container);
	}
});

document.addEventListener('DOMContentLoaded', function(){
	// listen for the form...
	if (typeof window.MktoForms2 !== 'undefined') {

		function showThankYou(){
			document.body.classList.add('thank-you');
		}

		window.MktoForms2.whenReady(function (form) {
			form.onSuccess(function (values, followUpUrl) {
				showThankYou();
				return false;
			});
		});
	}
});

// watch for the 

class FixedHeader {
	constructor( el ){
		this.el = el;
		this.buffer = 10;
		this.scrollStart = 0;
		this.lastScrollY = 0;
		this.scrollDirection = true;

		this.intersectionObserver = new IntersectionObserver((entries) => this.onIntersect(entries), {
			rootMargin: '-50px'
		});
		this.intersectionObserver.observe( document.querySelector('.hero-banner') );

		const ul = this.el.querySelector('ul');
		ul.classList.add('nav');
		ul.querySelectorAll('li').forEach( li => {
			li.classList.add('nav-item');
			li.querySelector('a').classList.add('nav-link');
		});

		new ScrollSpy(document.body, {
			target: ul
		});

		window.addEventListener('scroll', (e)=>this.onScroll(e));
		window.addEventListener('resize', ()=>this.updateFixedHeaderHeight());
		this.updateFixedHeaderHeight();
	}

	onIntersect( entries ){
		const [entry] = entries;
		this.heroVisible = entry.isIntersecting;
		this.update();
	}

	onScroll(e){
		this.scrollDirection = window.scrollY > this.lastScrollY;
		this.lastScrollY = window.scrollY;
		this.update();
	}

	update(){
		this.el.classList.toggle('show', !this.heroVisible);
	}

	updateFixedHeaderHeight(){
		this.el.style.setProperty('--fixed-header-height', this.el.getBoundingClientRect().height+'px');
		document.documentElement.style.setProperty('--fixed-header-height', this.el.getBoundingClientRect().height+'px');

	}

}
document.addEventListener('DOMContentLoaded', () => {
	
	const fixedHeader = document.querySelector('.fixed-header');
	if( fixedHeader ){
		new FixedHeader(fixedHeader);
	}
});
